import { Button } from '../../../../button/Button';
import { PipelineListTrackers } from '../../../tracking/pipeline-list-trackers';
import { useAnalyticsTracker } from '../../../../tracking/hooks/useAnalyticsTracker';
import { Tooltip } from '../../../../tooltip/Tooltip';

export function CreatePipelineButton({
  label,
  createPipeline,
  creatingPipeline,
  disabled = false,
  disabledReason = ''
}: {
  label?: string;
  disabled?: boolean;
  disabledReason?: string;
  createPipeline: (selectedSourceType?: string) => void;
  creatingPipeline: boolean;
}) {
  const { eventTrack } = useAnalyticsTracker();

  return (
    <Tooltip dataId='' title={disabledReason} disabled={!disabled}>
      <Button
        dataId='create-pipeline'
        size='md'
        icon='plus'
        className='ml-5'
        onClick={() => {
          eventTrack({
            action: PipelineListTrackers.PIPELINE_TRACKER_PIPELINE_LIST_CREATE_PIPELINE_CLICK
          });

          createPipeline();
        }}
        disabled={creatingPipeline || disabled}
      >
        {creatingPipeline ? 'Creating...' : label || 'Create Pipeline'}
      </Button>
    </Tooltip>
  );
}
